// extracted by mini-css-extract-plugin
export default {"b_p_adiv":"Btnpencil_b_p_adiv__jYdcA","b_p_img":"Btnpencil_b_p_img__pfnpv","pencildown":"Btnpencil_pencildown__dZE0Q"};